import { RootStateOrAny } from 'react-redux';
import { AnyAction } from 'redux';
import { ADD_NOTIFICATION_FAILURE, ADD_NOTIFICATION_REQUEST, ADD_NOTIFICATION_SUCCESS, CLEAR_NOTIFICATION_VALUES, FETCH_NOTIFICATION_COUNT_FAILURE, FETCH_NOTIFICATION_COUNT_REQUEST, FETCH_NOTIFICATION_COUNT_SUCCESS, FETCH_NOTIFICATION_FAILURE, FETCH_NOTIFICATION_REQUEST, FETCH_NOTIFICATION_SUCCESS, RESET_NOTIFICATIONS_STATE, UPDATE_NOTIFICATION_FAILURE, UPDATE_NOTIFICATION_REQUEST, UPDATE_NOTIFICATION_SUCCESS } from './actionType';
import { LOGOUT } from '../auth/actionType';

export const initialState = {
  notification: {
    type: 'applied',
    description: '',
  },
  isLoading: false,
  isAddedSuccessfully: false,
  notifications: [],
  error: "",
  isUpdating: false,
  isUpdatedSuccessfully: false,
  count: 0,
  isCounting: false,
};

const reducer = (
  state: RootStateOrAny = initialState,
  action: AnyAction
): object => {
  const { type, payload } = action;

  switch (type) {
    case ADD_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoading: true,
        notification: {
          ...state.notification,
          ...payload.notification,
        },
        error: ""
      };
    case ADD_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAddedSuccessfully: true,
        notification: {
          ...initialState.notification,
        },
      };
    case ADD_NOTIFICATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAddedSuccessfully: false,
        error: payload.error,
      };
    case FETCH_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: "",
      };
    case FETCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notifications: payload.notifications,
      };
    case FETCH_NOTIFICATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    case UPDATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isUpdating: true,
        notification: { ...state.notification, ...payload.notification },
      };
    case UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isUpdating: false,
        isUpdatedSuccessfully: true,
      };
    case UPDATE_NOTIFICATION_FAILURE:
      return {
        ...state,
        isUpdating: false,
        isUpdatedSuccessfully: false,
      };
    case FETCH_NOTIFICATION_COUNT_REQUEST:
      return {
        ...state,
        isCounting: true,
        error: "",
      };
    case FETCH_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        isCounting: false,
        count: payload.count,
      };
    case FETCH_NOTIFICATION_COUNT_FAILURE:
      return {
        ...state,
        isCounting: false,
        error: payload.error,
      };
    case CLEAR_NOTIFICATION_VALUES:
      return {
        ...state,
        notification: null,
        isAddedSuccessfully: false,
        isUpdating: false,
        isUpdatedSuccessfully: false,
      }
    case RESET_NOTIFICATIONS_STATE:
      return {
        ...state,
        notifications: [],
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;